module.exports = __webpack_public_path__ + "79ba1eb9e96aa6f254100a93374a5bab.MP3";